import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import { EMPTY_ARRAY, EMPTY_OBJECT } from '../../../constants/globalConstants'
import { MaskedInput, createDefaultMaskGenerator } from 'react-hook-mask'
import Login from '../../../components/global/login'
import { matchPassword, restrictInValidCharPassword, validateEmail, validatePassword, validatePhone } from '../../../utils/helper'
const phoneMaskGenerator = createDefaultMaskGenerator('(999) 999-9999')
import { getVehicleModelList } from '../../../redux/actions/VehicleListAction'



function SignUp(props) {




    const { setPage, isLoggedIn, dispatch, formData, setFormData, formError, partnerDetails } = props
    const [isLoginModal, setLoginModal] = useState(false)
    const [zipcode, setZipcode] = useState()
    const [caller, setCaller] = useState()
    // show and hide passowrd 
    const [countryCode, setCountryCode] = useState('US')
    const [cpasswordShown, setCPasswordShown] = useState(false)
    const [mpasswordShown, setMPasswordShown] = useState(false)
    const [vehicleDetailsList, setVehicleDetailsList] = useState(EMPTY_ARRAY)

    // for disbaled functionallty 
    const [loginData, setLoginData] = useState(EMPTY_OBJECT)


    const handleInputFieldsData = (e) => {
        const { name, value } = e.target

        if (name === 'zipcode') {
            let str = value
            let pattern = /\d/
            str.match(pattern) ? setZipcode('') : setZipcode('The zipcode contain at least a number.')
            setFormData({ ...formData, 'zipcode': value })
        }
        setFormData({ ...formData, [name]: value })

    }

    const handlePhoneChange = (value) => {
        setFormData({ ...formData, ['phone']: value })
    }

    const getVehical = () => {
        dispatch(getVehicleModelList(partnerDetails?.facilities?.[0]?.country_code)).then((res) => {
            setVehicleDetailsList(res)
            setFormData({ ...formData, ['state']: formData?.selFaclity?.geolocations?.state, ['city']: formData?.selFaclity?.geolocations?.city })
        })
    }

    useEffect(() => {
        setPage('signup')
        getVehical()
        setCountryCode(partnerDetails?.facilities?.[0]?.country_code)
        if (isLoggedIn) {
            const signupFormData = JSON.parse(localStorage.getItem('userData'))
            setLoginData(signupFormData?.user)
            if (signupFormData?.user && Object.values(signupFormData?.user)?.length > 0) {
                // if (signupFormData?.user &&  Object.values(signupFormData?.user)?.length > 0) {
                const loggedInUserData = signupFormData?.user
                formData['firstname'] = loggedInUserData?.first_name ? loggedInUserData?.first_name : formData?.first_name
                formData['lastname'] = loggedInUserData?.last_name ? loggedInUserData?.last_name : formData?.last_name
                formData['email'] = loggedInUserData?.email ? loggedInUserData?.email : formData?.email
                formData['phone'] = loggedInUserData?.phone_number ? loggedInUserData?.phone_number : formData?.phone
                formData['address1'] = loggedInUserData?.address ? loggedInUserData?.address : formData?.address1
                formData['address2'] = loggedInUserData?.address2 ? loggedInUserData?.address2 : formData?.address2
                formData['city'] = loggedInUserData?.city ? loggedInUserData?.city : formData?.city
                formData['state'] = loggedInUserData?.state ? loggedInUserData?.state : formData?.state

                formData['zipcode'] = loggedInUserData?.pincode ? loggedInUserData?.pincode : formData?.pincode
                formData['country'] = loggedInUserData?.country ? loggedInUserData?.country : formData?.country
                formData['company_name'] = loggedInUserData?.company_name ? loggedInUserData?.company_name : formData?.company_name
                setFormData({ ...formData })
            }
        } else {
            formData['country'] = countryCode
            setFormData({ ...formData })
        }

    }, [EMPTY_ARRAY, isLoggedIn])

    const handleModalOpen = () => {
        setLoginModal(true)
        setCaller('signup')
    }

    // show and hide password 
    const togglePasswordVisiblity = (e, key) => {
        if (key === 'password') {
            setMPasswordShown(mpasswordShown ? false : true)
        }
        if (key === 'cpassword') {
            setCPasswordShown(cpasswordShown ? false : true)
        }
    }


    return (


        <div >
            <h4 className="text-center my-4 mb-4">Account Information </h4>
            {!isLoggedIn && <div className="bg-white card p-3 mb-4">
                <p className="m-0">
                    <button type='button' className="btn btn-outline-primary" onClick={handleModalOpen} data-bs-target="#loginModal">LOG
                        IN</button> <strong> OR CREATE ACCOUNT BELOW</strong><br /><small
                            className="text-danger">*You must log in or create a new account to
                        proceed.</small>
                </p>
            </div>}

            <div className="mt-2">
                <div className="row g-2">
                    <div className="col-sm-6">
                        <div className="mb-2">
                            <label className="form-label">First Name <span className='text-danger'> *</span></label>
                            <input
                                className="form-control "
                                id="firstname" name="firstname" placeholder="First Name"
                                maxLength={100}
                                minLength={1}
                                disabled={isLoggedIn ? true : false}
                                value={formData?.firstname ? formData?.firstname : ''}
                                onChange={handleInputFieldsData}
                                required="" type="text" />
                            <span className="form-text text-danger h-40">{formError == 'signup' && !formData?.firstname ? 'This field is required' : ''}</span>
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="mb-2">
                            {/* <span className='text-danger'> *</span> */}
                            <label className="form-label">Last Name</label>
                            <input
                                maxLength={100}
                                disabled={(!loginData?.last_name) ? false : true}
                                minLength={1}
                                className="form-control "
                                name="lastname" value={formData?.lastname ? formData?.lastname : ''} placeholder="Last Name" required="" type="text" onChange={handleInputFieldsData} />
                            {/* <span className="form-text text-danger h-40">{formError == 'signup' && !formData?.lastname ? 'This field is required' : ''}</span> */}
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="mb-2">
                            <label className="form-label">Email <span className='text-danger'> *</span></label><input
                                className="form-control "
                                maxLength={100}
                                disabled={isLoggedIn ? true : false}
                                minLength={1}
                                name="email" placeholder="Email" required="" type="email"
                                value={formData?.email ? formData?.email : ''}
                                onChange={handleInputFieldsData}
                                pattern="^[^@]+@[^@]+.[a-zA-Z]{2,6}" />
                            <span className="form-text text-danger h-40">{formError == 'signup' ? !formData?.email ? 'This field is required' : !validateEmail(formData?.email) ? 'Please enter a valid email address' : '' : ''}</span>
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="mb-2">
                            <label className="form-label">Phone </label>
                            <MaskedInput
                                maskGenerator={phoneMaskGenerator}
                                value={formData?.phone ? formData?.phone : ''}
                                type="text"
                                name="phone"
                                id="phone"
                                className="form-control"
                                required
                                // pattern="[0-9 \\-\(\)\]{14}"
                                maxLength={14}
                                minLength={14}
                                title="Please enter a valid phone number"
                                onInvalid={e => e.target.setCustomValidity('Please enter phone number')}
                                onInput={e => e.target.setCustomValidity('')}
                                placeholder="Phone Number"
                                onChange={handlePhoneChange}
                            />
                            <span className="form-text text-danger h-40">{formError == 'signup' ? !formData?.phone ? '' : !validatePhone(formData?.phone) ? 'Please enter a valid phone number' : '' : ''}</span>
                        </div>
                    </div>


                </div>
                <div className="row g-2">
                    <div className="col-sm-6">
                        <div className="mb-2">
                            <label className="form-label">Company Name </label>
                            <input
                                value={formData?.company_name ? formData?.company_name : ''}
                                type="text"
                                name="company_name"
                                id="company_name"
                                className="form-control"
                                required
                                // pattern="[0-9 \\-\(\)\]{14}"
                                maxLength={200}
                                title="Please enter Company Name"
                                onChange={handleInputFieldsData}
                                placeholder="Company Name"
                            />
                            {/* <span className="form-text text-danger h-40">{formError == 'signup' ? !formData?.phone ? 'This field is required' : !validatePhone(formData?.phone) ? 'Please enter a valid phone number' : '' : ''}</span> */}
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="mb-2">
                            <label className="form-label">Billing Address<span className='text-danger'> *</span></label><input
                                className="form-control "
                                name="address1" placeholder="Address Line 1" required=""
                                value={formData?.address1 ? formData?.address1 : ''}
                                onChange={handleInputFieldsData}
                                maxLength={200}
                                type="text" />
                            <span className="form-text text-danger h-40">{formError == 'signup' && !formData?.address1 ? 'This field is required' : ''}</span>
                        </div>
                    </div>
                    {/* <div className="col-sm-6">
                        <div className="mb-2">
                            <label className="form-label">Address Line 2 </label><input
                                className="form-control ng-untouched ng-pristine ng-valid"
                                name="address2" placeholder="Address Line 2 (optional)"
                                value={formData?.address2 ? formData?.address2 : ''}
                                onChange={handleInputFieldsData}
                                type="text" /></div>
                    </div> */}
                    <div className="col-sm-6">
                        <div className="mb-2">
                            <label className="form-label">City <span className='text-danger'> *</span></label><input
                                className="form-control "
                                maxLength={100}
                                name="city" value={formData?.city ? formData?.city : ''} placeholder="City" required="" type="text" onChange={handleInputFieldsData} />
                            <span className="form-text text-danger h-40">{formError == 'signup' && !formData?.city ? 'This field is required' : ''}</span>
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="mb-2">
                            <label className="form-label">Country <span className='text-danger'> *</span></label>
                            <select className='form-select form-control' value={formData?.country} placeholder="country" name="country" id='country' onChange={(e) => handleInputFieldsData(e)}>
                                {/* <option value=''>Select an option</option> */}
                                {(vehicleDetailsList?.country?.length > 0) && vehicleDetailsList?.country?.map((item, itemIndex) =>
                                    item?.country_code == countryCode ? <option key={(itemIndex + 1)} value={item?.country_code}>{item?.country_code}</option> : null)}
                            </select>

                            <span className="form-text text-danger h-40">{formError == 'signup' && !formData?.country ? 'This field is required' : ''}</span>
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="mb-2">
                            <label className="form-label">State <span className='text-danger'> *</span></label>
                            <select className='form-select form-control' value={formData?.state} placeholder="State" name="state" id='state' onChange={(e) => handleInputFieldsData(e)}>
                                <option value=''>Select an option</option>
                                {(vehicleDetailsList?.state?.length > 0) && vehicleDetailsList?.state?.map((item, itemIndex) => <option key={(itemIndex + 1)} value={item?.state_code} selected={item?.id == formData.state || item?.state_code == formData.state}>{item?.state_code}</option>)}
                            </select>
                            {/* <input
                                className="form-control "
                                name="state" placeholder="State" required=""
                                value={formData?.state ? formData?.state : ''}
                                onChange={handleInputFieldsData}
                                type="text" /> */}
                            <span className="form-text text-danger h-40">{formError == 'signup' && !formData?.state ? 'This field is required' : ''}</span>
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="mb-2">
                            <label className="form-label">Zipcode <span className='text-danger'> *</span></label><input
                                className="form-control "
                                maxLength="6" minLength="5" name="zipcode"
                                autoComplete="new-password"
                                value={formData?.zipcode ? formData?.zipcode : ''}
                                placeholder="Zip Code" required="" type="text" onChange={handleInputFieldsData} />
                            <span className="form-text text-danger h-40">{formError == 'signup' && !formData?.zipcode ? 'This field is required' : ''}{zipcode}</span>
                        </div>
                    </div>
                </div>


                {!isLoggedIn && <div className=" mt-2 ">
                    <p className="fw-bold mt-3 mb-2"  >
                        <span >Create Account Password <i className='text-danger' > * </i>
                            <span className="popoverSection position-relative"  >
                                <div className='small popoverContent position-absolute shadow-sm bg-white p-2 border'>Password must be between 8 and 15 characters long and include at least one uppercase letter, one lowercase letter, one digit (0-9), and one special character (!, @, $, %, ^, &, *, #,?,-).</div>
                                <i
                                    className="fa fa-question-circle "
                                >
                                </i>
                            </span>

                        </span>
                    </p>
                    <div className="row">
                        <div className="col-sm-6">
                            <div className="mb-2"><input
                                className="form-control "
                                name="password" placeholder="Create Password" required=""
                                value={formData?.password}
                                autoComplete="new-password"
                                onChange={(e) => setFormData({ ...formData, ['password']: restrictInValidCharPassword(e.target.value) })}
                                maxLength={15}
                                minLength={8}
                                type={(!mpasswordShown) ? 'password' : 'text'} />
                                <i className={(!mpasswordShown) ? 'fas fa-eye-slash miconClass' : 'fas fa-eye miconClass'} onClick={(e) => togglePasswordVisiblity(e, 'password')}></i>
                                {/* <span className="form-text text-danger h-40">{formError == 'signup' ? !formData?.password ? 'This field is required' : !validatePassword(formData?.password) ? 'Please enter a valid password ' : !matchPassword(formData?.password, formData?.cpassword) ? 'Passwords does not match' : '' : ''}</span> */}
                                <span className="form-text text-danger h-40">{formError == 'signup' ? !formData?.password ? 'This field is required' : !validatePassword(formData?.password) ? 'Password must be between 8 and 15 characters long and include at least one uppercase letter, one lowercase letter, one digit (0-9), and one special character (!, @, $, %, ^, &, *, #,?,-).' : !matchPassword(formData?.password, formData?.cpassword) ? 'Passwords does not match' : '' : ''}</span>

                            </div>
                        </div>
                        <div className="col-sm-6">
                            <div className="mb-2"><input
                                className="form-control "
                                value={formData?.cpassword}
                                autoComplete="new-password"
                                maxLength={15}
                                minLength={8}
                                name="cpassword" placeholder="Confirm Password" required=""
                                onChange={(e) => setFormData({ ...formData, ['cpassword']: restrictInValidCharPassword(e.target.value) })}
                                type={(!cpasswordShown) ? 'password' : 'text'} />
                                <i className={(!cpasswordShown) ? 'fas fa-eye-slash ciconClass' : 'fas fa-eye ciconClass'} onClick={(e) => togglePasswordVisiblity(e, 'cpassword')}></i>
                                {/* <span className="form-text text-danger h-40">{formError == 'signup' ? !formData?.cpassword ? 'This field is required' : !validatePassword(formData?.cpassword) ? 'Please enter a valid password ' : !matchPassword(formData?.password, formData?.cpassword) ? 'Passwords does not match' : '' : ''}</span> */}
                                <span className="form-text text-danger h-40">{formError == 'signup' ? !formData?.cpassword ? 'This field is required' : !validatePassword(formData?.cpassword) ? 'Password must be between 8 and 15 characters long and include at least one uppercase letter, one lowercase letter, one digit (0-9), and one special character (!, @, $, %, ^, &, *, #,?,-).' : !matchPassword(formData?.password, formData?.cpassword) ? 'Passwords does not match' : '' : ''}</span>

                            </div>
                        </div>
                    </div>

                </div>
                }
            </div>
            <Login isLoginModal={isLoginModal} setLoginModal={setLoginModal} caller={caller} />
        </div>
    )
}

SignUp.propTypes = {
    dispatch: PropTypes.func,
    data: PropTypes.object,
    events: PropTypes.object,
    loader: PropTypes.bool,
    getCard: PropTypes.func,
    passData: EMPTY_ARRAY,
    setPage: PropTypes.func,
    isLoggedIn: PropTypes.bool,
    formData: PropTypes.object,
    setFormData: PropTypes.func,
    formError: PropTypes.string,
    partnerDetails: PropTypes.object,
}

SignUp.defaulProps = {
    dispatch: noop,
    data: EMPTY_OBJECT,
    events: EMPTY_OBJECT,
    loader: PropTypes.bool,
    getCard: PropTypes.func,
    passData: EMPTY_ARRAY,
    setPage: noop,
    isLoggedIn: false,
    formData: EMPTY_OBJECT,
    setFormData: noop,
    formError: undefined,
    partnerDetails: EMPTY_OBJECT,
}


function mapStateToProps({ paymentReducer }) {
    return {
        data: paymentReducer,
    }

}
export default connect(mapStateToProps)(SignUp)
